// extracted by mini-css-extract-plugin
module.exports = {"loaderBouncing":"Loader_loaderBouncing__QoeFL","spin":"Loader_spin__1PfuO"};